import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "Vilka kameror kan jag använda med ORBIT Cable Cam?",
      answer:
        "ORBIT Cable Cam är kompatibel med alla kameror upp till 3 kg tilsammans med tillhörande adapterfästen. Detta inkluderar de flesta DSLR-kameror, spegellösa kameror, actionkameror och smarttelefoner med adapter. Vill du vara säker på att din kamera passar? Tveka inte att kontakt oss, vi hjälper er gärna!",
    },
    {
      question: "Hur långt tid tar det från installation till första tagning",
      answer:
        "För en erfaren användare går det enkelt att installera systemet på under 5 minuter.",
    },
    // {
    //   question: "Vad är räckvidden för appkontrollen?",
    //   answer:
    //     "Bluetooth-anslutningen fungerar upp till 50 meter under optimala förhållanden. WiFi Direct-anslutningen utökar detta intervall till ungefär 100 meter för mer långväga drift.",
    // },
    {
      question: "Är det svårt att kontrollera kameraförelserna?",
      answer:
        "Inte alls. Vår app erbjuder användaren både möjlighet att utföra förprogrammerade rörelser eller att kontrollera kamerans perspektiv samt hastighet i realtid. För den mer erfarna användaren erbjuder vi även mer avancerade rörelsefunktioner.",
    },
    {
      question: "Vilken hastighet kan ORBIT Cable Cam röra sig i?",
      answer:
        "ORBIT Cable Cam kan röra sig i allt från extremt långsamma rörelser för time-lapse till hastigheter upp till cirka 35 km/h. Detta ger full flexibilitet – från mjuka, cinematiska kamerarörelser till snabba actionsekvenser.",
    },
    // {
    //   question: "Kan den användas i regn eller hårt väder?",
    //   answer:
    //     "Cable Cam har ett IP65-värde, vilket betyder att det är skyddat mot damm och lätta vattenstrålär från vilken riktning som helst. Det kan hantera lätt regn, dimma och dammiga förhållanden, men är inte utformat för nedsänkning eller kraftiga regnskurar.",
    // },
    // {
    //   question: "Vilken typ av support erbjuder ni?",
    //   answer:
    //     "Vi tillhandahåller en 2-årig garanti, gratis uppdateringar av inbyggd programvara via appen och tillgång till vårt skaparcommunity-forum. Vårt supportteam är tillgängligt 7 dagar i veckan via e-post eller chatt.",
    // },
  ];

  return (
    <div className="min-h-screen">
      <Header />

      <section className="py-16 px-6 bg-background min-h-[600px]">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-5xl font-bold mb-16 text-center">
            Vanliga frågor
          </h1>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-border rounded-lg px-6"
              >
                <AccordionTrigger className="text-left font-semibold hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQ;
